import type { CustomError } from 'store/models';
import type { ErrorType } from 'store/models/errors';

import { isEmpty } from './common';

export const getErrorMessage = (errorObject: unknown = {}): ErrorType => {
  if (typeof errorObject === 'string') {
    return {
      errorCode: '',
      message: errorObject,
    };
  }

  if (isEmpty(errorObject)) {
    return {
      errorCode: '',
    };
  }

  const keys: string[] = Object.keys(errorObject as CustomError) || [];
  const errorObjectName: string = keys.includes('data') ? 'data' : 'error';
  const errorCode = `${(errorObject as CustomError)[errorObjectName]?.error_code || ''}`;
  const errorMessage =
    (errorObject as CustomError)[errorObjectName]?.message ||
    (errorObject as CustomError)[errorObjectName]?.error_message ||
    (errorObject as CustomError)[errorObjectName]?.errorMessage ||
    (errorObject as CustomError)?.errorMessage;
  return {
    message: (errorMessage || '') as string,
    errorCode,
  };
};

export const setErrorIfNoValue = (fieldName: string) => new Error(`Error: no ${fieldName} for creating request`);
